import FormattedMessage from 'I18n/components/FormattedMessage';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { Text } from 'foundations-components/components/Text';
import { selectConnectedForms } from '../../../selectors/connectedForms';
import { getLanguageNameFromCode } from '../../../utils/langUtils';
import { useMemo } from 'react';
import { useAppSelector } from '../../../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export default function TranslateTemplateUISelectGroup(props) {
  const connectedForms = useAppSelector(selectConnectedForms);
  const connectedFormOptions = useMemo(() => [{
    //Resolving CG-50418 - allows removing support form ID from variants
    text: 'No form selected',
    value: ''
  }, ...connectedForms.map(form => ({
    text: form.name,
    value: form.guid
  }))], [connectedForms]);
  return /*#__PURE__*/_jsx(AccordionItem, {
    title: /*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "heading-100",
      children: props.title
    }),
    marginBlockStart: "400",
    children: props.languages.map((lang, idx) => {
      const isPrimary = idx === 0;
      const onChange = e => props.onChange(lang, e.target.value);
      const value = props.values.get(lang, '');
      return /*#__PURE__*/_jsx(FormControl, {
        verticalSeparation: "flush",
        label: getLanguageNameFromCode(lang),
        labelTooltip: isPrimary ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.templateEditor.translateModal.primaryLanguageFieldTooltip"
        }) : null,
        children: /*#__PURE__*/_jsx(Select, {
          readOnly: isPrimary,
          onChange: onChange,
          options: connectedFormOptions,
          placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.templateEditor.translateModal.sections.supportForm.fieldLabels.supportSelectFormPlaceholder"
          }),
          value: value
        })
      }, lang);
    })
  });
}